import React, { useEffect, useMemo, useState } from "react";
import { DatePicker, Modal, Typography } from "antd";
import dayjs from "../../../utils/dayjs";
import { daysJsFormat } from "../../../utils/constants";
import { groupBillsByDocumentDate } from "./groupBillsByDocumentDate";

const { Text } = Typography;

export const BillsExportDateModal = ({
  open,
  bills,
  onCancel,
  onConfirm,
  confirmLoading,
}) => {
  const groups = useMemo(() => groupBillsByDocumentDate(bills), [bills]);
  const [groupDates, setGroupDates] = useState({});

  useEffect(() => {
    if (!open) {
      return;
    }

    const initialDates = {};
    groups.forEach(group => {
      initialDates[group.key] = group.date;
    });
    setGroupDates(initialDates);
  }, [open, groups]);

  const allDatesSet = groups.every(group => groupDates[group.key]);

  const handleConfirm = () => {
    const updates = groups.map(group => ({
      billIds: group.billIds,
      documentDate: groupDates[group.key].startOf("day").toISOString(),
    }));
    onConfirm(updates);
  };

  const renderBillLabels = groupBills => {
    return groupBills
      .map(bill => `N° ${bill.bill_number}`)
      .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
      .join(", ");
  };

  return (
    <Modal
      title="Date de document"
      open={open}
      onCancel={onCancel}
      onOk={handleConfirm}
      okText="Exporter"
      cancelText="Annuler"
      okButtonProps={{ disabled: !allDatesSet }}
      confirmLoading={confirmLoading}
      destroyOnClose
    >
      <Text type="secondary">
        Définissez la date de document à utiliser pour l&apos;export.
      </Text>

      <div style={{ marginTop: 16 }}>
        {groups.length === 1 && !groups[0].date ? (
          <DatePicker
            style={{ width: "100%" }}
            format={daysJsFormat.day}
            value={groupDates[groups[0].key] || null}
            onChange={value =>
              setGroupDates(current => ({
                ...current,
                [groups[0].key]: value,
              }))
            }
            placeholder="Date de document"
          />
        ) : (
          groups.map(group => (
            <div
              key={group.key}
              style={{
                marginBottom: 16,
                paddingBottom: 16,
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <Text strong>{renderBillLabels(group.bills)}</Text>
              <DatePicker
                style={{ width: "100%", marginTop: 8 }}
                format={daysJsFormat.day}
                value={groupDates[group.key] || null}
                onChange={value =>
                  setGroupDates(current => ({
                    ...current,
                    [group.key]: value,
                  }))
                }
                placeholder="Date de document"
              />
            </div>
          ))
        )}
      </div>
    </Modal>
  );
};
